import React from "react";
import ParticipantCheckInQRCode from "./ParticipantCheckInQRCode";
import { formatParticipantQrTitle } from "../shared/utils/eventCalendarParticipantQr";

/**
 * Single prominent check-in QR card (carousel slide).
 * Always shows the participant QR; status badge reflects event registration.
 */
function ParticipantCheckInQRCard({
  displayName,
  titledDisplayName,
  userId,
  accountId,
  serverUrl,
  participantType = "self",
  eventName = "",
  statusKey = "ready",
  statusLabel = "Registered",
  size = 180,
}) {
  if (!userId || !accountId) return null;

  const edgeClass =
    participantType === "child"
      ? "EventCalendar-participant-qr-card--child"
      : "EventCalendar-participant-qr-card--self";

  const title = (titledDisplayName || "").trim() || formatParticipantQrTitle({ displayName, participantType });
  const eventLabel = (eventName || "").trim();
  const badgeMod = statusKey ? `EventCalendar-participant-qr-card__badge--${statusKey}` : "";

  return (
    <article className={`card EventCalendar-participant-qr-card EventCalendar-participant-qr-card--featured ${edgeClass}`}>
      <div className="card-body">
        <div className="card-main">
          <div className="card-main-details">
            <h3 className="card-title EventCalendar-participant-qr-card__name">{title}</h3>
            {eventLabel ? (
              <p className="EventCalendar-participant-qr-card__label">{eventLabel}</p>
            ) : null}
            <p className="EventCalendar-participant-qr-card__hint">
              Show this code at the event so staff can scan you in.
            </p>
            {statusLabel ? (
              <span className={`EventCalendar-participant-qr-card__badge ${badgeMod}`}>{statusLabel}</span>
            ) : null}
          </div>
          <div className="card-main-qr EventCalendar-participant-qr-card__qr-wrap">
            <ParticipantCheckInQRCode
              userId={userId}
              accountId={accountId}
              serverUrl={serverUrl}
              size={size}
              className="card-qr-wrap"
            />
          </div>
        </div>
      </div>
    </article>
  );
}

export default ParticipantCheckInQRCard;
